import AxiosInstance from "../services/networkServices";

/** Verified store purchases: vote-button keeps and live gifts. */
export const listSales = async ({ page = 1, limit = 20, kind = "all", search = "" } = {}) => {
  const response = await AxiosInstance.post("/admin/sales/list", {
    page,
    limit,
    kind,
    ...(search ? { search } : {}),
  });
  return response.data;
};
